<template>
  <el-dialog :title="title"
             :visible.sync="visible"
             width="720px"
             append-to-body=""
             @closed='handleClose'
             :close-on-press-escape="false">
    <el-form :model="certificate"
             label-position="right"
             :rules="rules"
             ref="ruleForm"
             label-width="85px">
      <el-form-item label="检测编号:"
                    prop="certNumber">
        <el-input v-model="certificate.certNumber"></el-input>
      </el-form-item>
      <el-form-item label="检测人员:"
                    prop="inspector">
        <el-input v-model="certificate.inspector"></el-input>
      </el-form-item>
      <el-form-item label="检测时间:"
                    prop="inspectionTime">
        <el-date-picker v-model="certificate.inspectionTime"
                        style="width: 100%"
                        type="date"
                        :editable="false"
                        placeholder="选择检测时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="检测地址:"
                    prop="inspectionAddress">
        <el-input v-model="certificate.inspectionAddress"></el-input>
      </el-form-item>
      <el-form-item prop="vendorId"
                    label="选择企业:">
        <span v-if=" certificate.vendorName ">{{ certificate.vendorName }}</span>
        <span v-else>请选择</span>
        <i style="cursor: pointer;margin-left: 10px"
           class="el-icon-edit"
           @click="selectEnt"></i>
      </el-form-item>
      <el-form-item label="检测报告:"
                    prop="certFile">
        <custom-upload-file v-model="certificate.certFile"
                            :limit="10"
                            rolate
                            @update:loading="handleLoading"
                            accept="image/*,.pdf" />
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false"
                 :loading="loading">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit"
                 :loading="loading">确 定</el-button>
    </span>
    <org-select-ent-modal ref="ent"
                          :callback="entCallback" />
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import CustomUploadFile from '@/components/public/custom-upload-file.vue'
import OrgSelectEntModal from '../certificate/busi/org-select-ent-modal.vue'
export default {
  name: 'inspect-report-modal',
  components: { CustomUploadFile, OrgSelectEntModal },
  props: {
    fetch: { type: Function, required: true }
  },
  data () {
    return {
      loading: false,
      visible: false,
      certificate: {
        inspectReportId: null,
        certNumber: '',
        regulatorId: null,
        inspector: '',
        inspectionTime: null,
        inspectionAddress: '',
        certFile: [],
        vendorId: null,
        vendorName: '',
        tradeType: 3,
        inspectReportSource: 2
      },
      rules: {
        certNumber: [ { required: true, message: '请输入检测编号', trigger: 'blur' } ],
        certFile: [ { type: 'array', required: true, message: '请上传检测报告', trigger: 'change' } ],
        // regulatorId: [ { required: true, message: '请选择管理/服务机构', trigger: 'blur' } ],
        inspector: [ { required: true, message: '请输入检测人员', trigger: 'blur' } ],
        inspectionTime: [ { required: true, message: '请选择检测时间', trigger: 'blur' } ],
        vendorId: [{ required: true, message: '请选择企业', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    title ({ certificate }) {
      const { inspectReportId } = certificate
      return (inspectReportId ? '修改检测报告' : '新建检测报告')
    }
  },
  methods: {
    init (row = {}) {
      this.certificate = { ...this.certificate, ...row }
      this.visible = true
    },
    selectEnt () {
      this.$refs.ent.fetch()
    },
    entCallback (row) {
      this.certificate.vendorId = row.vendorId
      this.certificate.vendorName = row.vendorName
      this.$refs.ruleForm.validateField('vendorId')
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
      this.certificate = {
        ...this.certificate,
        inspectReportId: null,
        certNumber: '',
        regulatorId: null,
        inspector: '',
        inspectionTime: null,
        inspectionAddress: '',
        certFile: [],
        vendorId: null,
        vendorName: '',
        tradeType: 3,
        inspectReportSource: 2
      }
    },
    handleLoading (loading) {
      this.loading = loading
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.addcertificate()
        }
      })
    },
    addcertificate () {
      this.loading = true
      const { inspectionTime, certFile, inspectReportId } = this.certificate
      const dispatch = inspectReportId ? 'updateinspectreport' : 'addinspectreport'
      this.$store.dispatch(`inspect/${dispatch}`, {
        payload: {
          ...this.certificate,
          inspectionTime: +inspectionTime,
          certFile: certFile.map(item => item.url).join(',')
        },
        success: (res) => {
          this.loading = false
          this.visible = false
          this.fetch && this.fetch()
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
